import logo from "./logo.svg";
import Header from "./Header";
import Main from "./Main";
import Main2 from "./Main2";
import "./App.css";
import Main3 from "./Main3";
import Carousel from "./Carousel";
import Main4 from "./Main4";
import Card from "./Card";
import Photos from "./Photos";
import Footer from "./Footer"
import Navbar1 from "./Navbar";

function App() {
  return (
    <>
      <Navbar1/>
      <Header />
      <Main />
      <Carousel />
      <Main2 />
      <Main3 />
      <Main4 />
      <Card />
      <Photos />
      <Footer />
    </>
  );
}

export default App;
